// AI Service — stub en attente d'un modèle local (Ollama, llama.cpp…)
//
// Toutes les fonctions gardent leurs signatures d'origine pour que les
// composants continuent de compiler sans modification.
// Remplacer les stubs ci-dessous par des appels à l'API backend /ai/*
// lorsqu'un LLM sera configuré.
import type { OfferSuggestion, CampaignIdea, Restaurant } from '../../shared/types';

const AI_UNAVAILABLE =
  "L'assistant IA est temporairement indisponible. Cette fonctionnalité sera disponible prochainement.";

export const chatWithRemi = async (
  _message: string,
  _history: { role: 'user' | 'model'; text: string }[],
  _context: unknown,
): Promise<string> => {
  return AI_UNAVAILABLE;
};

export const generateDynamicInsight = async (
  _section: string,
  _context: unknown,
): Promise<string> => {
  return "Analysez vos segments pour identifier vos clients les plus rentables.";
};

export const generateAnalyticalReport = async (
  _theme: string,
  _data: unknown,
): Promise<string> => {
  return AI_UNAVAILABLE;
};

export const generateOffer = async (_objective: string): Promise<OfferSuggestion> => {
  throw new Error(AI_UNAVAILABLE);
};

export const generateCampaign = async (
  _objective: string,
  _segment: string,
): Promise<CampaignIdea> => {
  throw new Error(AI_UNAVAILABLE);
};

export const generateMapInsight = async (
  _competitors: Restaurant[],
  _userRestaurant: Restaurant,
): Promise<string> => {
  return "Analysez vos concurrents pour identifier des opportunités de différenciation.";
};
